import React from 'react';
import type { StepItem } from '../types';

type Props = {
  steps: StepItem[];
};

export default function HowItWorks({ steps }: Props) {
  return (
    <section id="how-it-works" className="bg-white text-slate-950">
      <div className="mx-auto max-w-7xl px-6 py-24 md:py-28">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm uppercase tracking-[0.22em] text-sky-600">How it works</p>
          <h2 className="mt-4 text-4xl font-semibold tracking-tight text-slate-950 md:text-5xl">
            Three quiet steps, not a campaign
          </h2>
          <p className="mt-4 text-lg leading-8 text-slate-600">
            Connect what you already have, set offers that respect your margins, and let real
            results decide what gets paid.
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {steps.map((step) => (
            <div
              key={step.step}
              className="rounded-[30px] border border-slate-200 bg-slate-50 p-8 shadow-sm transition hover:-translate-y-0.5 hover:bg-white"
            >
              <div className="inline-flex rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-sm font-semibold text-sky-700">
                {step.step}
              </div>
              <h3 className="mt-5 text-2xl font-semibold tracking-tight text-slate-950">
                {step.title}
              </h3>
              <p className="mt-4 leading-7 text-slate-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
